export default "__VITE_ASSET__BvIMCP2x__"